<div class="clientlist-component" data-hook="clientlist-component">
  <table class="table table-striped">
    <thead>
    <tr>
      <th>Nachname</th>
      <th>Vorname</th>
      <th><span>Firmenname</span></th>
      <th>Kategorie</th>
      <th ng-show="vm.mode === 'patient'">Test</th>
      <th>Aktion</th>
    </tr>
    </thead>
    <tr ng-repeat="client in vm.clients">
      <td>{{client.primarycontact.lastname}}</td>
      <td>{{client.primarycontact.firstname}}</td>
      <td>{{client.companydata.name}}</td>
      <td>{{client.companydata.type}}</td>
      <td ng-show="vm.mode === 'patient'"><span ng-show="client.test === true"><i class="fa fa-check"></i></span></td>
      <td>
        <button class="btn btn-primary" ng-click="vm.goToRecord(client, vm.redirect)">Akte</button>
        <button ng-hide="vm.mode === 'patient'" class="btn btn-danger" uib-tooltip="L&ouml;schen"  ng-click="vm.removeClient(client)">
          <i class="fa fa-remove"></i>
        </button>
      </td>
    </tr>
  </table>
  
  
  <div uib-pagination total-items="vm.totalItems"
                  items-per-page="vm.pageSize"
                  max-size="10"
                  first-text="Erste"
                  last-text="Letzte"
                  next-text="N&auml;chste"
                  previous-text="Vorige"
                  boundary-links="true"
                  rotate="false"
                  ng-model="vm.currentPage"
                  ng-change="vm.pageChanged()"></div>
</div>